import { createFileRoute, Link } from "@tanstack/react-router";
import { DashboardShell, PlaceholderCard } from "@/components/DashboardShell";
import { CUSTOMER_NAV } from "@/lib/nav";

export const Route = createFileRoute("/_authenticated/customer/subscriptions")({
  head: () => ({
    meta: [
      { title: "Subscriptions · Landoo" },
      { name: "description", content: "Manage your Landoo customer subscription." },
    ],
  }),
  component: () => (
    <DashboardShell title="Subscriptions" role="Customer" items={CUSTOMER_NAV}>
      <PlaceholderCard
        title="Free Browse"
        description="Upgrade to unlock unlimited owner contacts and priority support."
      >
        <Link
          to="/plans"
          className="inline-flex rounded-full bg-brand px-4 py-2 text-xs font-semibold text-brown-dark shadow-soft"
        >
          View plans
        </Link>
      </PlaceholderCard>
    </DashboardShell>
  ),
});
